import {ChangeEvent, SyntheticEvent} from 'react'
import '../styles/Forms.scss'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined'
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined'
import Button from '@mui/material/Button'

const shortenFileName = (selectedFileName : string) => {
    const FILE_NAME_SIZE = 30
    if (selectedFileName.length <= FILE_NAME_SIZE) {
        return selectedFileName
    } else {
        return selectedFileName.substring(0, FILE_NAME_SIZE) + '...'
    }
}

const UploadCommonLoadingButton = ({
                                       selectedFileName,
                                       unselectFile,
                                       parseFile,
                                       className = '',
                                       name = 'upload-file',
                                       id = 'upload-file',
                                       variant = 'contained',
                                       acceptedFileType = '.xlsx'
                                   }:
                                       {
                                           selectedFileName: string,
                                           name?: string, id?: string, className?: string,
                                           variant?: 'outlined' | 'contained',
                                           acceptedFileType?: string,
                                           unselectFile: (event: SyntheticEvent) => void,
                                           parseFile: (event: ChangeEvent<HTMLInputElement>) => void
                                       }) => {
    return <Button data-testid="file-upload-btn" component="label" variant={variant} color="primary" className={className}
                          startIcon={!selectedFileName && <UploadOutlinedIcon/>}
                          endIcon={selectedFileName && <DeleteForeverOutlinedIcon onClick={unselectFile}/>}>
        {shortenFileName(selectedFileName) || 'Choose File from Computer'}
        <input name={name} id={id} onChange={parseFile} hidden type="file"
               accept={acceptedFileType}/>
    </Button>


}

export default UploadCommonLoadingButton


